import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Box,
  Divider,
  FormControl,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { useForm } from "react-hook-form";
import { nanoid } from 'nanoid';

import {
  ListOptions,
  MasterMfaPreference,
  MasterRole,
} from "../../../models/Master";
import { MyAccountModel } from "../../../models/MyAccount";
import fontWeight from "../../../styles/mui/fontWeight";
import {
  FaPencilIcon,
  FilterByHeaderStyle,
  FilterIcon,
  FilterText,
  HeaderInputFieldWidth,
  IconFilter,
  MainContainer,
  NoRecordFound,
} from "../style/style";
import { flexRow } from "../../../styles/mui/styles/display";
import { ButtonContained } from "../../../app/common/button";
import {
  ButtonClearStyle,
  ButtonVerifyStyle,
  ContainerStyle,
  HorizontalDivider,
  PaginationGrid,
  StyledTableHead,
  tableCell,
  tableCellDynamic,
  tableCellDynamic2,
} from "../../../app/styles/styles";
import colors from "../../../styles/colors/colors";
import { getCurrnetPageFullPath, getUaserPageViewPayload, getValue, isAdmin } from "../../../utils";
import AddUser from "../containers/AddUser";
import {
  AdminFilterBy,
  getValidMessageType,
  UserDetailsInAdminActionDispatchTypes,
  UserListActionDispatchTypes,
  UserListHeaderLabel,
} from "../../../constants/User";
import EditUser from "../containers/EditUser";
import { FormInputDropdown } from "../../../components/FormInputDropdown";
import { FormInputTextStandard } from "../../../components/FormInputTextStandard";
import {
  AdminUserList,
  PortalUpdateData,
  UserListPayload,
  UserPageTrack,
} from "../../../models/User";
import PaginationItem from "../../../app/common/pagination/components/PaginationItem";
import { PER_PAGE } from "../../../constants/FunctionalUtils";
import { searchListPayload } from "../../../constants/Admin";
import { ApplicationTitles, UserRole } from "../../../constants/HomePage";
import { UserDetailsActionDispatchTypes, UserStatusActionDispatchTypes } from "../../../constants/MyAccount";
import AddPortalUpdate from "../containers/AddPortalUpdate";
import { rules } from "../../../utils/validation/Validation";
import { ApplicationRoute } from "../../../constants/ApplicationUrl";
import { redirectUri } from "../../../constants/Config";

export interface PropsFromDispatch {
  getMasterRole: () => void;
  getMasterServiceProvider: () => void;
  postAdminUserList: (payload: UserListPayload) => void;
  getMfaPreference: () => void;
  resetStates: (actionType: string) => void;
  getPortalUpdate: () => void;
  postUserPageTrack: (payload: UserPageTrack) => void;
  getMasterHealthPlan: () => void;
}
export interface PropsFromState {
  masterMfaPreferenceState: MasterMfaPreference[];
  updateUserDetailsState: MyAccountModel;
  updateUserDetailsLoading: boolean;
  loggedInUser: MyAccountModel;
  masterRoleState: MasterRole[];
  masterServiceProviderState: ListOptions[];
  userListState: AdminUserList;
  addUserState: MyAccountModel;
  userListLoading: boolean;
  portalUpdate: PortalUpdateData;
  getActivateDeActivateUserState: string;
  getAdminSelectedUserByEmail: (userEmail: string) => void;
}

export interface Data {
  filterBy: string;
  search: string;
}

type AllProps = PropsFromState & PropsFromDispatch;

const AdminPortal: React.FC<AllProps> = ({
  loggedInUser,
  getMasterServiceProvider,
  masterServiceProviderState,
  postAdminUserList,
  userListState,
  getMfaPreference,
  resetStates,
  updateUserDetailsState,
  addUserState,
  portalUpdate,
  getPortalUpdate,
  getActivateDeActivateUserState,
  getAdminSelectedUserByEmail,
  postUserPageTrack,
  getMasterHealthPlan
}) => {
  const methods = useForm<any>({
    defaultValues: "",
  });
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [disabledSearchInput, setDisabledSearchInput] = useState<boolean>(true);
  const { handleSubmit, control, setValue, getValues, reset, watch, clearErrors } = methods;
  const [openAddUserModal, setOpenAddUserModal] = useState<boolean>(false);
  const [userList, setUserList] = useState<any>(userListState);
    const [alignmentIsActive, setAlignmentIsActive] = React.useState('Active');
  

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignmentIsActive(newAlignment);
  };
  const [openUpdateUserModal, setOpenUpdateUserModal] =
    useState<boolean>(false);
  const [selectedUserData, setSelectedUserData] = useState<any>("");
  const [pageNumber, setPageNumber] = useState(1);
  const count = Math.ceil(
    userListState.searchResponse && userListState.totalRows
      ? Number(userListState.totalRows) / PER_PAGE
      : 1 / PER_PAGE
  );

  useEffect(() => {
    const subscription = watch((_value: any, { name }: any) => {
      if (name === "search" && !isEmpty(_value.search) && _value.search.length > 0) {
        setDisabled(false);
      }
      if (name === "filterBy" && !isEmpty(_value.filterBy)) {
        setDisabledSearchInput(false)
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.ADMIN),
        getCurrnetPageFullPath(),
        redirectUri,
        ""
      )
    );
  }, []);

  const searchCriteria = (value: any, pageFlag: boolean, page: number) => {
    resetStates(UserListActionDispatchTypes.USER_DETAILS_RESET);
    setPageNumber(page);
      const payload = {
        ...searchListPayload,
        [value.filterBy]: value.filterBy === "npiId" && isEmpty(value.search) ? null : value.search,
        isRoleType:
          loggedInUser.providerPortalUser.roleType === UserRole.PROVIDER_ADMIN
            ? UserRole.PROVIDER_ADMIN
            : "",
        userId:
          loggedInUser.providerPortalUser.roleType === UserRole.PROVIDER_ADMIN
            ? loggedInUser.providerPortalUser.userId
            : "",
        pageNo: pageFlag ? page : 1,
        status: alignmentIsActive
      };
      return payload;
  };

  const onSubmit = (data: Data) => {
    postAdminUserList(searchCriteria(data, false, 1));
  };

  const handlePageChange = (_e: ChangeEvent<unknown>, page: number) => {
    resetStates(UserListActionDispatchTypes.USER_DETAILS_RESET);
    setPageNumber(page);
    postAdminUserList(
      searchCriteria(
        {
          filterBy: getValues("filterBy"),
          search: getValues("search"),
        },
        true,
        page
      )
    );
  };

  useEffect(() => {
    postAdminUserList(searchCriteria({
      filterBy: getValues("filterBy"),
      search: getValues("search"),
    }, false, 1));
  },[alignmentIsActive])

  useEffect(() => {
    if (getValues("filterBy") === null || isEmpty(getValues("filterBy"))) {
      reset();
      setDisabled(true);
      setDisabledSearchInput(true)
    } else {
      setDisabled(false);
      setDisabledSearchInput(false)
    }
  }, [getValues("filterBy")]);

  const handleSearch = () => {
    handleSubmit(onSubmit)();
  };

  const handleClear = () => {
    setValue("filterBy", null);
    setValue("search", "");
    reset();
    postAdminUserList(searchCriteria({filterBy: null}, false, 1));
  };

  useEffect(() => {
    reset({ search: "", filterBy: null });
    clearErrors("search");
    postAdminUserList(searchCriteria({filterBy: null}, false, 1));
  }, []);

  useEffect(() => {
    setUserList(userListState);
  }, [userListState]);
  const [isOpenAddPortalUpdateModal, setIsOpenAddPortalUpdateModal] =
    useState<boolean>(false);

  const addButtons = () => {
    return isAdmin(loggedInUser) ? (
      <>
        <ButtonContained
          id="btnSearch"
          onClick={() => handleSearch()}
          label="Search"
          disabled={disabled}
          style={ButtonVerifyStyle}
        />
        <ButtonContained
          id="btnClear"
          onClick={() => handleClear()}
          label="Clear"
          style={ButtonClearStyle}
        />
        <ButtonContained
          id="btnAddUser"
          onClick={() => {
            setOpenAddUserModal(true);
            reset();
          }}
          label="Add New User"
          style={ButtonVerifyStyle}
        />
      </>
    ) : null;
  };
  useEffect(() => {
    getMasterServiceProvider();
    getMasterHealthPlan();
  }, [getMasterServiceProvider]);
  useEffect(() => {
    getMfaPreference();
  }, [getMfaPreference]);
  useEffect(() => {
    setOpenUpdateUserModal(false);
    resetStates(UserDetailsActionDispatchTypes.UPDATE_USER_DETAILS_RESET);
    resetStates(UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_RESET)
    if (updateUserDetailsState.providerPortalUser.roleType !== "") {
      handleClear();
    }
  }, [updateUserDetailsState]);
  useEffect(() => {
    setOpenAddUserModal(false);
    if (addUserState.providerPortalUser.roleType !== "") {
      handleClear();
    }
  }, [addUserState]);

  useEffect(() => {
    if (!isEmpty(getValue(portalUpdate, "userId", ""))) {
      getPortalUpdate();
    }
  }, [portalUpdate]);

  const cellRender = (
    label: any,
    flag: boolean,
    removeBorder: boolean,
    item: any
  ) => {
    return (
      <>
        <TableCell
          sx={
            flag === false
              ? tableCellDynamic(flag, removeBorder)
              : tableCellDynamic2(flag, removeBorder)
          }
        >
          {label === "action" ? (
            <IconButton
              onClick={() => {
                setSelectedUserData(item);
                setOpenUpdateUserModal(true);
              }}
            >
              <FaPencilIcon />
            </IconButton>
          ) : (
            <Typography
              variant="subtitle1"
              fontWeight={fontWeight[5]}
              color={colors.fonts[4]}
            >
              {label}
            </Typography>
          )}
        </TableCell>
      </>
    );
  };
  const rowRender = (data: any) => {
    return (
      <>
        {data && data.length && !isEmpty(data[0].email)
          ? data.map((item: any, index: number) => (
              <>
                <TableRow key={nanoid()}>
                  {cellRender(
                    item.firstName,
                    false,
                    data.length - 1 === index,
                    item
                  )}
                  {cellRender(
                    item.lastName,
                    false,
                    data.length - 1 === index,
                    item
                  )}
                  {cellRender(
                    item.email,
                    false,
                    data.length - 1 === index,
                    item
                  )}
                  {cellRender(
                    item.roleType,
                    false,
                    data.length - 1 === index,
                    item
                  )}
                  {cellRender(
                    item.status,
                    false,
                    data.length - 1 === index,
                    item
                  )}
                  {cellRender(
                    item.approve,
                    false,
                    data.length - 1 === index,
                    item
                  )}
                  {cellRender("action", false, data.length - 1 === index, item)}
                </TableRow>
              </>
            ))
          : NoRecordFound(data[0].userId)}
      </>
    );
  };

  useEffect(() => {
    if (getActivateDeActivateUserState) {
      handleSearch();
      if (selectedUserData && !isEmpty(selectedUserData.email)) {
        getAdminSelectedUserByEmail(selectedUserData.email);
      }
    }
    return () => {
      if (!isEmpty(getActivateDeActivateUserState)) {
        resetStates(UserStatusActionDispatchTypes.USER_STATUS_RESET);
      }
    };
  }, [getActivateDeActivateUserState]);

  useEffect(() => {
    if (!openUpdateUserModal) {
      resetStates(UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_RESET)
    }
  },[openUpdateUserModal])

  return (
    <Box>
      <Grid container>
        <Grid size={{ xs: 12 }} mt={2} mb={1} sx={flexRow}>
          <Grid container sx={FilterByHeaderStyle} ml={2}>
            <FormControl
              variant="standard"
              fullWidth
              sx={HeaderInputFieldWidth}
            >
              <FormInputDropdown
                name="filterBy"
                control={control}
                label="Filter By :"
                list={AdminFilterBy}
                readOnly={false}
                onChangeHandler={() => {
                  setValue("search", "");
                }}
              />
            </FormControl>
            <FormControl
              variant="standard"
              fullWidth
              sx={HeaderInputFieldWidth}
            >
              <FormInputTextStandard
                name="search"
                control={control}
                label="Search :"
                textLength={50}
                helper={getValues("filterBy") ? rules.search : {}}
                readOnly={disabledSearchInput}
              />
            </FormControl>
            <Grid pt={1.8}>
              {addButtons()}
              {loggedInUser?.providerPortalUser?.roleType ===
                UserRole.TANGO_ADMIN && (
                <>
                  <ButtonContained
                    id="btnAddPortalUpdate"
                    onClick={() => setIsOpenAddPortalUpdateModal(true)}
                    label="Add Portal Update"
                    style={ButtonVerifyStyle}
                  />
                  <ButtonContained
                    id="btnAgencyAccess"
                    onClick={() => navigate(ApplicationRoute.AGENCY_ACCESS)}
                    label="Agency Access"
                    style={ButtonVerifyStyle}
                  />
                   <ButtonContained
                    id="btnNotification"
                    onClick={() => navigate(ApplicationRoute.NOTIFICATION)}
                    label="Notification"
                    style={ButtonVerifyStyle}
                  />
                </>
              )}
            </Grid>
            <Grid size={{ xs: 12 }} mt={2}>
              <Box sx={FilterIcon}>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  marginTop={1}
                >
                  <IconFilter />
                  <Typography
                    variant="subtitle1"
                    color={colors.black[5]}
                    fontWeight={fontWeight[4]}
                  >
                    Filter by status:
                  </Typography>
                  <Grid container spacing={2}>
                    <ToggleButtonGroup
                      color="primary"
                      value={alignmentIsActive}
                      exclusive
                      onChange={handleChange}
                      aria-label="Platform"
                      sx={FilterText}
                    >
                      <ToggleButton value="">
                        All Users
                      </ToggleButton>
                      <ToggleButton value="Active">
                        Active
                      </ToggleButton>
                      <ToggleButton value="Deactive">
                        Deactivated
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Grid>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Divider sx={HorizontalDivider} />
        </Grid>
        <Grid size={{ xs: 12 }} sx={MainContainer}>
          <Grid size={{ xs: 12 }} pl={"1rem"} pb={"1rem"}>
            <TableContainer component={Paper} sx={ContainerStyle}>
              <Table stickyHeader>
                <StyledTableHead>
                  <TableRow>
                    {UserListHeaderLabel.map((data: any) => (
                      <TableCell key={data.label} sx={tableCell}>
                        <Box sx={data.style?.cell}>
                          <Typography
                            color={colors.black[16]}
                            variant="body1"
                            fontWeight={fontWeight[3]}
                          >
                            {data.label}
                          </Typography>
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                </StyledTableHead>
                <TableBody>{rowRender(userList.searchResponse)}</TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }} pr={6} sx={PaginationGrid}>
        <PaginationItem
          count={count}
          page={pageNumber}
          handlePageChange={handlePageChange}
        />
      </Grid>
      {openAddUserModal && (
        <AddUser
          loggedInUser={loggedInUser}
          modalFlag={openAddUserModal}
          setModalflag={setOpenAddUserModal}
          masterServiceProviderState={masterServiceProviderState}
        />
      )}
      {openUpdateUserModal && (
        <EditUser
          loggedInUser={loggedInUser}
          modalFlag={openUpdateUserModal}
          setModalflag={setOpenUpdateUserModal}
          setSelectedUserData={setSelectedUserData}
          selectedUserData={selectedUserData}
          masterServiceProviderState={masterServiceProviderState}
        />
      )}
      {isOpenAddPortalUpdateModal && (
        <AddPortalUpdate
          isOpenModal={isOpenAddPortalUpdateModal}
          setIsOpenModal={setIsOpenAddPortalUpdateModal}
        />
      )}
    </Box>
  );
};

export default AdminPortal;
